import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import {RaikoAlert, raikoAlertTypes} from "../../raikoComponents/raikoAlert/RaikoAlert";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import RaikoSimpleMultiLineInputOutlined
    from "../../raikoComponents/raikoCustomInput/RaikoSimpleMultiLineInputOutlined";
import ButtonDivisionSection from "../ButtonDivisionSection/ButtonDivisionSection";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import {useState} from "react";

const VideoDetailSeoDetail = () => {
    const [metaTitle, setMetaTitle] = useState("")
    const [metaDescription, setMetaDescription] = useState("")
    const [metaRobots, setMetaRobots] = useState("")
    const [metaKeyboards, setMetaKeyboards] = useState("")
    const [openGraphItems, setOpenGraphItems] = useState([])
  return(
      <RaikoBaseCardContainer>
          <RaikoGridOneColumn>
              <RaikoAlert
                  type={raikoAlertTypes.info}
                  title={"بهینه سازی موتور های جستجو"}
                  description={[
                      "* برای بهتر دیده شدن مقاله ی خود در موتور های جستجو باید مقاله را به بهترین روش ممکن به موتور های جستجو معرفی نمایید.",
                      "* متا ها ابزار هایی برای معرفی صحیح صفحات و محتواهای آن ها به موتور های جستجو هستند."
                  ]}
              />

              <RaikoSimpleInputOutlined
                  labelText={"Meta Title"}
                  setValue={setMetaTitle}
                  value={metaTitle}/>

              <RaikoSimpleMultiLineInputOutlined
                  labelText={"Meta Description"}
                  setValue={setMetaDescription}
                  value={metaDescription}/>

              <RaikoSimpleInputOutlined
                  labelText={"Meta Robots"}
                  setValue={setMetaRobots}
                  value={metaRobots}/>

              <RaikoSimpleInputOutlined
                  labelText={"Meta Keyboards"}
                  setValue={setMetaKeyboards}
                  value={metaKeyboards}/>

              <ButtonDivisionSection>
                  <ButtonPrimaryRaiko label={"بروزرسانی"}/>
              </ButtonDivisionSection>
          </RaikoGridOneColumn>
      </RaikoBaseCardContainer>
  )
}
export default VideoDetailSeoDetail;